module.exports = __webpack_public_path__ + "static/media/Storeicon.821576ec.svg";